import { memo } from 'react';

import { useBalanceReportExpandContext } from 'pages/Finance/BalanceReport/context/BalanceReportExpandContext';
import { useRecordContext } from 'react-admin';

import { BalanceRow } from './BalanceReportDatagrid';
import { BalanceReportDatagridAccountNameField } from './BalanceReportDatagridAccountNameField';
import { BalanceReportDatagridNameField } from './BalanceReportDatagridNameField';

type Props = {
  label: string;
  source: string;
};

const BalanceReportDatagridNameCellComponent: React.FC<Props> = () => {
  const record = useRecordContext<BalanceRow>();
  const { expanded, toggleRow } = useBalanceReportExpandContext();

  if (!record) {
    return null;
  }

  if (record.type === 'account') {
    return <BalanceReportDatagridAccountNameField record={record} />;
  }

  return (
    <BalanceReportDatagridNameField
      isExpanded={!!expanded[record.id]}
      record={record}
      toggleRow={toggleRow}
    />
  );
};

export const BalanceReportDatagridNameCell = memo(BalanceReportDatagridNameCellComponent);
